<div>
  <h5 mat-dialog-title>{{ 'updateCompany' | translate }}</h5>
  <form [formGroup]="formGroup" fxLayout="column">

    <!-- Categories -->
    <mat-form-field color="accent">
      <mat-label>{{ 'categories' | translate }}</mat-label>
      <mat-select formControlName="categories" multiple>
        <mat-option *ngFor="let category of (categories$ | async)?.data" [value]="category.id">
          {{category.nameTranslations[currentLanguage]}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Email -->
    <mat-form-field color="accent">
      <mat-label>{{ 'email' | translate }}</mat-label>
      <input matInput formControlName="email">
    </mat-form-field>

    <!-- Phone -->
    <mat-form-field color="accent">
      <mat-label>{{ 'phone' | translate }}</mat-label>
      <input matInput formControlName="phone">
    </mat-form-field>

    <!-- Website -->
    <mat-form-field color="accent">
      <mat-label>{{ 'website' | translate }}</mat-label>
      <input matInput formControlName="website">
    </mat-form-field>

    <!-- AgentURL -->
    <mat-form-field color="accent">
      <mat-label>{{ 'agentUrl' | translate }}</mat-label>
      <input matInput formControlName="agentUrl">
    </mat-form-field>

    <!-- Name translations -->
    <div formGroupName="nameTranslations">
      <span>{{ 'nameTranslations' | translate }}</span>
      <div *ngFor="let language of languages" fxLayout="column">
        <mat-form-field color="accent">
          <mat-label>{{ language.code }}</mat-label>
          <input matInput [formControlName]="language.id">
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- Actions -->
  <div mat-dialog-actions fxLayoutAlign="end">
    <button mat-button (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button (click)="onSave()" color="accent">{{ 'save' | translate }}</button>
  </div>
</div>
